import { render, staticRenderFns } from "./video-loading-overlay.vue?vue&type=template&id=5af1ede6&scoped=true"
import script from "./video-loading-overlay.vue?vue&type=script&lang=js"
export * from "./video-loading-overlay.vue?vue&type=script&lang=js"
import style0 from "./video-loading-overlay.vue?vue&type=style&index=0&id=5af1ede6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1ede6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af1ede6')) {
      api.createRecord('5af1ede6', component.options)
    } else {
      api.reload('5af1ede6', component.options)
    }
    module.hot.accept("./video-loading-overlay.vue?vue&type=template&id=5af1ede6&scoped=true", function () {
      api.rerender('5af1ede6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/video-loading-overlay.vue"
export default component.exports